import { SvgFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC, useEffect, useRef } from 'react'
import invariant from 'tiny-invariant'
import s from './SvgRender.module.scss'
export type SvgRenderProps = {
  media: SvgFragment
  className?: string
}
const SvgRender: FC<SvgRenderProps> = ({ media, className }) => {
  invariant(
    media.__typename === 'UmbracoMediaVectorGraphics',
    'SvgRender: media must be of type UmbracoMediaVectorGraphics',
  )

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref?.current || !media.id) return
    const svgUrl = `https://media.gubi.com/${media.id}.svg`

    //fetch svg from external url and append it to ref
    fetch(svgUrl)
      .then((res) => res.text())
      .then((svg) => {
        if (!svg) return
        ref.current?.appendChild(
          new DOMParser().parseFromString(svg, 'image/svg+xml').documentElement,
        )
      })
      .catch((err) => console.error(err))
  }, [])
  return (
    <div ref={ref} data-id={media.id} className={clsx(s.root, className)}></div>
  )
}

export default SvgRender
